import React, {useState} from 'react';
import {Tabs, Cell, Checkbox, Input, Picker, Toast, Popup, Popper, Button, Radio} from 'zarm';
import {IconFont, ExamineTemplate} from '@wap/components';
import request from '@utils/request';
import utils from '@seeing/utils';
import Tabulation from '@wap/components/Tabulation';
import Keyboard from '@wap/components/Keyboard';
import './index.less';

const {Panel} = Tabs;
const orderList = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th'];
class CheckCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      panelList: [],
      submitParams: {}, // 提交的参数
      visible: false,
      wearGlassesVisible: false, // 试戴片次数
      wearGlassesDataSource: [], // 试戴片选择列表
      ifShowWearData: false, // 试戴片次数数据是否显示
      wearEyeType: 'OD', // 试戴片选择的type
      pickerData: {
        // 选择框
        field: '',
        type: '',
        dataSource: [],
      },
      odBrand: {list: []}, // od选择的品牌相关数据
      osBrand: {list: []}, // os选择的品牌相关数据
      beforeData: {}, // 之前选择的数据
      whichTimes: undefined,
      whichTimesName: undefined,
      extraExamData: {}, // 头部额外的检查项数据
      keyboardVisible: false, // 是否使用键盘的弹框是否显示
      eyeType: 'OD',
      keyBoardExamKey: '', // 键盘的检查项的指标key
      keyBoardExamValue: '', // 键盘的检查项的名称
      keyBoardExamPlaceholder: '', // 键盘检查项的placeholder
    };
    this.tabRef = React.createRef();
  }
  componentDidMount() {
    this.fetchData();
    this.fetchPanelList();
  }

  fetchData() {
    const {data} = this.props;
    const {examContent} = data;
    // 获取头部额外的检查项数据
    this.handleExtraExamData();
    // 获取品牌列表
    request.get('/goods_service/goods/ok_app/brand/list', {}).then((data) => {
      const dataSource = data.map((item) => {
        return {
          value: item.relaBrandCode,
          label: item.relaBrandName,
          brandId: item.relaBrandId,
        };
      });
      this.brandList = dataSource;
      this.initData(examContent);
    });
  }

  fetchPanelList() {
    const {data} = this.props;
    const {nodeId, tenantId, examContent = {}} = data;
    const {whichTimes = 0, whichTimesName} = examContent;
    request
      .get('/form_designer/ok_treatment/ok_app/inspection_glasses', {
        nodeId,
        tenantId,
      })
      .then((result) => {
        // 默认选中的tab
        const activeKey = result.findIndex(
          (item) => item.whichTimes === whichTimes
        );
        const panelList = result.map((item) => {
          if (item.whichTimes === whichTimes) {
            let param = {
              ...examContent,
              whichTimes: whichTimes || item.whichTimes,
              whichTimesName: whichTimesName || item.whichTimesName,
            };
            if (Object.keys(examContent).length === 0) {
              param = {...item};
            }
            // return { ...examContent, whichTimes: whichTimes || item.whichTimes, whichTimesName: whichTimesName || item.whichTimesName };
            return {...param};
          }
          return item;
        });
        const wearGlassesDataSource = panelList.map((item, index) => {
          let values = {
            ...item,
            label: orderList[index],
            value: index,
          };
          return values;
        });
        this.setState({
          wearGlassesDataSource,
          panelList,
          ifShowWearData: panelList.length > 0,
        });
      });
  }

  /**
   * 获取头部额外的检查项数据
   */
  handleExtraExamData = () => {
    const {data} = this.props;
    const {nodeId, tenantId} = data;
    request
      .get('/form_designer/ok_treatment/ok_app/card_top/exam_data', {
        nodeId,
        tenantId,
      })
      .then((res) => {
        this.setState({extraExamData: res || {}});
      });
  };
  /**
   * 初始化数据
   */
  initData = (data = {}) => {
    const {data: examData = {}} = this.props;
    const {examCode} = examData;
    const {list = []} = data;
    const fieldsValues = list[0] || {};
    const odBrand = {};
    const osBrand = {};
    // console.log('data', data, 'examData', examData)
    const {whichTimes, whichTimesName, ...restFiledsValues} = fieldsValues;
    Object.keys(restFiledsValues).forEach((key) => {
      // console.log(key)
      const dataTypes = key.slice(0, 6);
      const type = dataTypes.split('data')[1];

      const propKey = key.slice(6);
      const relaPropKey =
        propKey === 'BrandCode' || propKey === 'Rem'
          ? propKey.replace(propKey[0], propKey[0].toLowerCase())
          : propKey;
      if ((type&&type.toLowerCase()) === 'od') {
        const currentBrand =
          this.brandList.find(
            (brand) => brand.value === fieldsValues.dataOdBrandCode
          ) || {};
        odBrand.brandName = currentBrand?.label;
        odBrand.brandId = currentBrand?.brandId;

        odBrand[relaPropKey] = fieldsValues[key];
      } else {
        const currentBrand =
          this.brandList.find(
            (brand) => brand.value === fieldsValues.dataOsBrandCode
          ) || {};
        osBrand.brandName = currentBrand?.label;
        osBrand.brandId = currentBrand?.brandId;
        osBrand[relaPropKey] = fieldsValues[key];
      }
    });
    if (odBrand.brandCode) {
      this.fetchPropsData(odBrand).then((odData) => {
        let data = odData;
        if (examCode === '85004') {
          data = odData.filter((item) => item.relaPropTry === 1) || [];
        }
        this.setState({
          odBrand: {...odBrand, list: data},
          whichTimes,
          whichTimesName,
        });
      });
    }
    if (osBrand.brandCode) {
      this.fetchPropsData(osBrand).then((osData) => {
        let data = osData;
        if (examCode === '85004') {
          data = osData.filter((item) => item.relaPropTry === 1) || [];
        }
        this.setState({
          osBrand: {...osBrand, list: data},
          whichTimes,
          whichTimesName,
        });
      });
    }
    // Promise.all(fetchList).then(([odData, osData]) => {
    //   this.setState({ odBrand: { ...odBrand, list: odData }, osBrand: { ...osBrand, list: osData }, whichTimes: {whichTimes, whichTimesName}})
    // })
  };

  /**
   * 选择品牌
   * @param {*} type
   */
  handleSelectBrand = (visible, type, field, list) => {
    const dataSource = (this.brandList || []).map((item) => {
      return {
        ...item,
        realValue: item.value,
      };
    });
    this.setState({visible, pickerData: {field, type, dataSource}});
  };
  /**
   * 选择品牌属性
   * @param {*} visible
   * @param {*} type
   * @param {*} field
   * @param {*} list
   */
  handleChangeBrandProp = (
    visible,
    type,
    field,
    list = [],
    keyBoardExamValue,
    name
  ) => {
    // 是否使用键盘
    const {useKeyBoard} = this.props;
    if (useKeyBoard === 1) {
      this.setState({
        eyeType: type.toUpperCase(),
        keyboardVisible: true,
        keyBoardExamKey: field,
        keyBoardExamValue,
        keyBoardExamPlaceholder: name,
      });
      return;
    }
    const dataSource = list.map((item, index) => {
      const {value, stock} = item;
      return {
        value: `choiId_${index}`,
        // label: item,
        label: (
          <span>
            {value}{' '}
            <span style={{color: +stock === 0 ? '#ec9232' : ''}}>{`${
              +stock > 0 ? `(${stock}片可用)` : '(无可用)'
            }`}</span>
          </span>
        ),
        realValue: value,
      };
    });
    this.setState({visible: visible, pickerData: {field, type, dataSource}});
  };
  /**
   * 页面初始状态，选择任意眼别的品牌，同时选中第二只眼睛相同品牌；
   * 如：左眼选中品牌，如果右眼品牌为空，则自动为右眼选中与左眼相同的品牌；
   * 后续修改不再同步
   * @param {*} type
   * @param {*} value
   * @returns
   */
  setOtherBrand = (type, value) => {
    const { odBrand, osBrand} = this.state;
    const otherBrand = type === 'Od' ? osBrand : odBrand;
    const field =  type === 'Od' ? 'osBrand' : 'odBrand';
    // const otherBrand = type === 'Od' ? osBrand : odBrand;
    if (!otherBrand.brandId){
      return {
        [field]: value
      }
    }
    return {};
  }
  /**
   * 选中数据
   */
  handleSelectedProps = (selected, field, type) => {
    console.log(selected, field, type, '=====', this.radioRef)

    const {data} = this.props;
    const {examCode} = data;
    const value = selected[0]?.value;
    const label =
      field === 'brandCode' ? selected[0]?.label : selected[0]?.realValue;
    const brandId = selected[0]?.brandId || '';
    const {odBrand, osBrand} = this.state;
    const realValue = field === 'brandCode' ? value : label;
    const filedValue = {};
    if (field === 'brandCode') {
      filedValue.brandId = brandId;
      filedValue[field] = value;
      filedValue.brandName = label;
    } else {
      filedValue[field] = label;
    }
    const {list: odList, ...odRest} = odBrand;
    const {list: osList, ...osRest} = osBrand;
    let searchParams = {};
    let newOdRest = {...odRest};
    let newOsRest = {...osRest};
    if (type === 'Od') {
      if (odRest[field] && odRest[field] !== realValue) {
        // 如果修改的是已选择的数据。则需要清空其他值
        const {brandCode, brandName, brandId} = odRest;
        newOdRest = {brandCode, brandName, brandId, ...filedValue};
      }
      searchParams = { ...newOdRest, ...filedValue };
    } else {
      if (osRest[field] && osRest[field] !== realValue) {
        // 如果修改的是已选择的数据。则需要清空其他值
        const {brandCode, brandName, brandId} = osRest;
        newOsRest = {brandCode, brandName, brandId, ...filedValue};
      }
      searchParams = {...newOsRest, ...filedValue};
    }
    searchParams[field] = searchParams[field] || '#{space}'
    this.fetchPropsData(searchParams).then((data) => {
      let list = data;
      if (examCode === '85004') {
        list = list.filter((item) => item.relaPropTry === 1) || [];
      }
      if (type === 'Od') {
        let setData = {
          ...newOdRest,
          ...filedValue,
          list,
        };
        if (field === 'brandCode') {
          setData = {...filedValue, list};
        }
        setData = this.handlePropsData(setData, field)
        const iniOtherBrand = this.setOtherBrand(type, setData);
        this.setState({odBrand: {...setData}, visible: false, ...iniOtherBrand});
      } else {
        let setData = {
          ...newOsRest,
          ...filedValue,
          list,
        };
        if (field === 'brandCode') {
          setData = {...filedValue, list};
        }
        setData = this.handlePropsData(setData, field)
        const iniOtherBrand = this.setOtherBrand(type, setData);
        this.setState({osBrand: {...setData}, visible: false, ...iniOtherBrand});
      }
    });
  };

  // 品牌属性只有一个值的时候直接填入
  handlePropsData = (data, field) => {
    let {list} = data;
    const newData = {};
    // 出了选中的当前属性外，其他属性只有一个值的时候直接填入
    list =  list.filter(item => item.relaPropKey !== field && item.choiceList?.length);
    list.forEach((item, index) => {
      const {choiceList = [], relaPropKey} = item;
      if (choiceList.length === 1) {
        newData[relaPropKey] = choiceList[0]?.value;
      }
    });
    if (Object.keys(newData).length === list.length) {
      return {...data, ...newData};
    }
    return data;
  };
  // 获取品牌属性；
  fetchPropsData = (params) => {
    const {data = {}} = this.props;
    const {examCode} = data;
    const {brandCode, ...rest} = params;
    // 处方的属性列表
    if (examCode === '85005') {
      const url = '/goods_service/goods/ok_app/attribute/prescription';
      return request.get(url, {brandCode: params.brandCode}, {});
    } else {
      // 验配卡的属性列表
      const url = '/goods_service/goods/ok_app/attribute_value/list';
      return request.post(
        url,
        {...rest, BrandCode: params.brandCode, BrandId: params.brandId},
        {}
      );
    }
  };
  /**
   * 保存
   */
  handleResult = () => {
    const {odBrand, osBrand, whichTimes, whichTimesName} = this.state;
    const {list: odList, whichTimes: odWhichTimes, ...odRest} = odBrand;
    const {list: osList, whichTimes: osWhichTimes, ...osRest} = osBrand;

    const params = {whichTimes, whichTimesName};
    odRest &&
      Object.entries({
        ...odRest,
        BrandName: odRest.brandName,
      }).forEach(([key, value]) => {
        const uperKey = key.trim().replace(key[0], key[0].toUpperCase());
        if (value !== '') {
          params[`dataOd${uperKey}`] = value;
        }
      });
    osRest &&
      Object.entries({
        ...osRest,
        BrandName: osRest.brandName,
      }).forEach(([key, value]) => {
        if(key[0]){
          const uperKey =key[0]&& key.trim().replace(key[0], key[0].toUpperCase());
          if (value !== '') {
            params[`dataOs${uperKey}`] = value;
          }
        }
      });
    const {data} = this.props;
    const {examContent} = data;

    return {
      ...data,
      examContent: {list: [params]},
    };
  };

  /**
   * 当前输入框的值改变时候
   */
  onInputChange = (name, value) => {
    this.setState({keyBoardExamKey: name, keyBoardExamValue: value});
  };

  /**
   * 输入框失去焦点
   */
  onInputBlur = (name, value, element) => {
    this.onInputChange(name, value);
  };

  /**
   * 下一页
   */
  onKeyNext = () => {
    this.tabRef.current.onNext();
  };

  /**
   * 键盘退格
   */
  onKeyBackspace = () => {
    this.tabRef.current.onBackspace();
  };

  /**
   * 类型切换
   * @param type 眼别类型
   */
  onKeyTypeChange = (type) => {
    const {odBrand = {}, osBrand = {}} = this.state;
    let name = '';
    if (type === 'OD') {
      const {odList = []} = odBrand;
      name = odList[0]?.relaPropKey;
    } else {
      const {osList = []} = odBrand;
      name = osList[0]?.relaPropKey;
    }
    this.tabRef.current.inputAutoFocusByName(name);

    this.setState({eyeType: type});
  };

  /**
   * inputKeyValueChange input的值返回，也可以在onInputChange方法中获取当前改变的值
   * @param value 键盘输入值改变
   */
  onKeyValueChange = (value) => {
    this.tabRef.current.inputKeyValueChange(value);
  };
  /**
   * 键盘的单个指标的保存
   */
  handleSaveKeyboardExam = () => {
    const {keyBoardExamKey, keyBoardExamValue, odBrand, osBrand, eyeType} =
      this.state;
    if (eyeType === 'OD') {
      odBrand[`${keyBoardExamKey}`] = keyBoardExamValue;
    } else {
      osBrand[`${keyBoardExamKey}`] = keyBoardExamValue;
    }
    this.setState({odBrand, osBrand, keyboardVisible: false});
  };

  renderHeader = (type, ifShowWearData) => {
    const {odBrand, osBrand} = this.state;
    if (ifShowWearData) {
      return (
        <div
          className={'headerItem'}
          onClick={() => this.handleWearGlassesVisible(true, type)}
        >
          {type}
          &emsp;
          <div>
            {type === 'OD'
              ? orderList[`${odBrand?.whichTimes}`]
              : orderList[`${osBrand?.whichTimes}`]}
          </div>
          <IconFont type="icon-zhankai" className="iconPointer" />
        </div>
      );
    }
    return type;
  };

  handleWearGlassesVisible = (wearGlassesVisible, wearEyeType) => {
    this.setState({wearGlassesVisible, wearEyeType});
  };

  // 选择试戴片次数
  handleWearGlassesData = (value) => {
    const {osBrand, odBrand, beforeData} = this.state;
    const [odValue, osValue] = [{}, {}];
    Object.entries(odBrand).forEach(([key, value]) => {
      if (key !== 'list') {
        const uperKey = key.trim().replace(key[0], key[0].toUpperCase());
        odValue[`dataOd${uperKey}`] = `${value}`;
      }
    });
    Object.entries(osBrand).forEach(([key, value]) => {
      if (key !== 'list') {
        const uperKey = key.trim().replace(key[0], key[0].toUpperCase());
        osValue[`dataOs${uperKey}`] = `${value}`;
      }
    });
    const {wearEyeType} = this.state;
    this.compareData(
      beforeData?.dataOdBrandCode ? beforeData : {...odValue, ...osValue},
      value[0],
      wearEyeType
    );
  };

  compareData = (beforeData, afterData, type) => {
    let [beforeValue, afterValue, obj] = [{}, {}, {}];
    if (type === 'OD') {
      afterValue = this.getWearValue('Od', afterData);

      beforeValue = this.getWearValue('Os', beforeData);
      afterValue['dataOdwhichTimes'] = `${afterData.value}`;
    } else {
      afterValue = this.getWearValue('Os', afterData);
      beforeValue = this.getWearValue('Od', beforeData);
      afterValue['dataOswhichTimes'] = `${afterData.value}`;
    }
    obj = {
      ...beforeValue,
      ...afterValue,
    };
    const content = {list: [{...obj}]};
    this.setState({
      beforeData: afterValue,
    });
    this.initData(content);
    this.setState({wearGlassesVisible: false});
  };

  getWearValue = (type, obj) => {
    const object = {};
    for (let key in obj) {
      if (key.indexOf(type) > -1) {
        object[key] = obj[key];
      }
    }

    if (object[`data${type}WhichTimes`]) {
      const value = object[`data${type}WhichTimes`];
      delete object[`data${type}WhichTimes`];
      object[`data${type}whichTimes`] = value;
    }
    return object;
  };

  // 备注修改
  handleInputChange = (value, type, filed) => {
    const {osBrand, odBrand} = this.state;
    if (type === 'od') {
      odBrand[filed] = value;
      this.setState({
        odBrand,
      });
    } else {
      osBrand[filed] = value;
      this.setState({
        osBrand,
      });
    }
  };
  /**
   * 清空选值
   */
  handledeleteValue = (field, type) => {
    const {data: examData = {}} = this.props;
    const {examCode} = examData;
    const { odBrand, osBrand } = this.state;
    const {list: odList, ...odRest} = odBrand;
    const {list: osList, ...osRest} = osBrand;
    let searchParams = {[field]: undefined}
    if (type === 'Od') {
      searchParams = { ...odRest, ...searchParams }
    } else {
      searchParams = { ...osRest,...searchParams }
    }

    this.fetchPropsData(searchParams).then((data) => {
      let list = data;
      if (examCode === '85004') {
        list = list.filter((item) => item.relaPropTry === 1) || [];
      }
      let setData = {
        ...searchParams,
        list,
      };
      if (type === 'Od') {
        // setData = this.handlePropsData(setData)
        this.setState({odBrand: {...setData}, visible: false});
      } else {
        this.setState({osBrand: {...setData}, visible: false});
      }
    });
  }
  /**
   * 关闭检查项的弹出层
   */
  handleClose = () => {
    this.setState({visible: false});
  };
  handleRadioChange = (value, field, type) => {
    const { pickerData = {} } = this.state;
    const { dataSource = [] } = pickerData;
    const selected = dataSource.filter(item => item.value === value)
    console.log(value, 'handleRadioChange', selected);
    this.handleSelectedProps(selected, field, type)
  }
  render() {
    const {
      visible,
      pickerData,
      odBrand = {},
      osBrand = {},
      extraExamData = {},
      keyboardVisible,
      eyeType,
      keyBoardExamKey,
      keyBoardExamValue,
      keyBoardExamPlaceholder,
      wearGlassesVisible,
      wearGlassesDataSource,
      ifShowWearData,
    } = this.state;

    const {od, os} = extraExamData;
    const {data, isShowRemark = false} = this.props;
    const types = ['Od', 'Os'];
    return (
      <>
        <div className="CheckCardContent">
          <div className="CheckCardRow">
            {types.map((type, index) => {
              const key = `${index + 1}`;
              return (
                <div className="CheckCardCol" key={key}>
                  <div className="header">
                    {this.renderHeader(type.toUpperCase(), ifShowWearData)}
                  </div>
                  <div className="baseInfo">{[od, os][index]}</div>
                  <div className="selectWrapper">
                    {type === 'Od' && (
                      <>
                        <div
                          className="brandSelect"
                          onClick={() =>
                            this.handleSelectBrand(true, type, 'brandCode')
                          }
                        >
                          <span className="brandName">品牌</span>
                          <span>：</span>
                          &emsp;
                          <span>{odBrand.brandName}</span>
                          <IconFont
                            type="icon-zhankai"
                            className="iconPointer"
                          />
                        </div>
                        {(odBrand.list || []).map((item) => {
                          const value = odBrand[item.relaPropKey];

                          const name =
                            item.relaPropNameTenant || item.relaPropName;
                          return (
                            <div
                              key={item.relaPropKey}
                              className="brandSelect"
                              onClick={() =>
                                !value && this.handleChangeBrandProp(
                                  true,
                                  type,
                                  item.relaPropKey,
                                  item.choiceList,
                                  odBrand[item.relaPropKey],
                                  name
                                )
                              }
                            >
                              <span className="brandName">{name}</span>
                              <span>：</span>
                              &emsp;
                              <span>{value || ''}</span>
                              {value ?
                              <IconFont
                                type="icon-guanbi1"
                                className="iconPointer"
                                onClick={() =>
                                  this.handledeleteValue(
                                    item.relaPropKey,
                                    type,
                                  )
                                }
                                /> :
                              <IconFont
                                type="icon-zhankai"
                                className="iconPointer"
                              />}
                            </div>
                          );
                        })}
                        {isShowRemark && (
                          <div className="remark">
                            <Input
                              style={{padding: '4px 4px 4px 24px'}}
                              onChange={(value) =>
                                this.handleInputChange(value, 'od', 'rem')
                              }
                              value={odBrand['rem']}
                              rows={3}
                              type="text"
                              maxLength={50}
                              placeholder="OD备注"
                            />
                          </div>
                        )}
                      </>
                    )}
                    {type === 'Os' && (
                      <>
                        <div
                          className="brandSelect"
                          onClick={() =>
                            this.handleSelectBrand(true, type, 'brandCode')
                          }
                        >
                          <span className="brandName">品牌</span>
                          <span>：</span>
                          <span>{osBrand.brandName}</span>
                          <IconFont
                            type="icon-zhankai"
                            className="iconPointer"
                          />
                        </div>
                        {(osBrand.list || []).map((item) => {
                          const value = osBrand[item.relaPropKey];
                          const name =
                            item.relaPropNameTenant || item.relaPropName;
                          return (
                            <div
                              key={item.relaPropKey}
                              className="brandSelect"
                              onClick={() =>
                               !value && this.handleChangeBrandProp(
                                  true,
                                  type,
                                  item.relaPropKey,
                                  item.choiceList,
                                  osBrand[item.relaPropKey],
                                  name
                                )
                              }
                            >
                              <span className="brandName">{name}</span>
                              <span>：</span>
                              <span>{value}</span>
                              {value?
                              <IconFont
                                type="icon-guanbi1"
                                className="iconPointer"
                                onClick={() =>
                                  this.handledeleteValue(
                                    item.relaPropKey,
                                    type,
                                  )
                                }
                                /> :
                              <IconFont
                                type="icon-zhankai"
                                className="iconPointer"
                              />}
                            </div>
                          );
                        })}
                        {isShowRemark && (
                          <div className="remark">
                            <Input
                              style={{padding: '4px 4px 4px 24px'}}
                              value={osBrand['rem']}
                              onChange={(value) =>
                                this.handleInputChange(value, 'os', 'rem')
                              }
                              rows={3}
                              maxLength={50}
                              type="text"
                              placeholder="OS备注"
                            />
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* <Picker
          visible={visible}
          value={pickerData.value}
          dataSource={pickerData.dataSource}
          onOk={(selected) =>
            this.handleSelectedProps(
              selected,
              pickerData.field,
              pickerData.type
            )
          }
          onCancel={() => this.handleSelectBrand(false)}
        /> */}
         <Popup
          visible={visible}
          direction="bottom"
          onMaskClick={this.handleClose}
          // afterOpen={this.handleOpen}
          // afterClose={this.handleClose}
          // destroy={false}
          mountContainer={() => document.body}
        >
          <div className="popup-box">
            <div className="popup_header">
              <div className="cancelBtn" onClick={this.handleClose}>
                取消
              </div>
              <div className="title">请选择</div>
            {/*  <Button className="save" onClick={(selected) =>  this.handleSelectedProps(*/}
            {/*  selected,*/}
            {/*  pickerData.field,*/}
            {/*  pickerData.type*/}
            {/*)}>*/}
            {/*    保存*/}
            {/*  </Button>*/}
            </div>
            <div className="popup_content2" style={{ minHeight: '200px' }}>
              <Radio.Group ref={r => this.radioRef = r} onChange={(selected)=>{this.handleRadioChange(
                  selected,
                  pickerData.field,
                  pickerData.type)}} type="button" defaultValue="1"  size='md' style={{ padding: '10px 16px 20px'}}>
                {pickerData.dataSource.map((item) => {
                  return <Radio value={item.value} key={item.value} item={item}>{item.label}</Radio>
                })}
              </Radio.Group>
            </div>
          </div>
        </Popup>

        {/* 选择试戴次数 */}
        <Picker
          visible={wearGlassesVisible}
          value={pickerData.value}
          dataSource={wearGlassesDataSource}
          onOk={(selected) => this.handleWearGlassesData(selected)}
          onCancel={() => this.handleWearGlassesVisible(false, '')}
        />

        {/* 键盘填写 */}
        {keyboardVisible && (
          <Popup
            visible={keyboardVisible}
            direction="bottom"
            onMaskClick={() => {
              this.setState({keyboardVisible: false});
            }}
            destroy={false}
            mountContainer={() => document.body}
          >
            <div className="popup-box">
              <div className="popup_header">
                <div
                  className="cancelBtn"
                  onClick={() => {
                    this.setState({keyboardVisible: false});
                  }}
                >
                  取消
                </div>
                <div className="title" />
                <div className="save" onClick={this.handleSaveKeyboardExam}>
                  保存
                </div>
              </div>
              <div className="popup_content">
                <Tabulation
                  border // input输入框的的边框是否显示
                  defaultMaxLength={1} // 整个组件默认的最大输入值，每个输入框可以通过 maxLength 自定义
                  defaultUnavailableText="@" // 整个组件默认的不可输入的字符
                  onInputChange={this.onInputChange} // 输入时候回调 name, value, inputElement?
                  onInputBlur={this.onInputBlur} // 输入框失去焦点后回调 name, value, inputElement?
                  ref={this.tabRef}
                >
                  {/* 最大可输入范围 */}
                  <Tabulation.TabInput
                    tabIndex={0}
                    name={keyBoardExamKey}
                    maxLength={7}
                    value={keyBoardExamValue}
                    placeholder={keyBoardExamPlaceholder}
                    className="filled_width"
                  />
                </Tabulation>
                <div>
                  <Keyboard
                    unavailableKeys={['@', '00', 'OD', 'OS', '下一项']}
                    eyeType={eyeType}
                    onKeyNext={this.onKeyNext}
                    onKeyBackspace={this.onKeyBackspace}
                    // onKeyTypeChange={this.onKeyTypeChange}
                    onKeyValueChange={this.onKeyValueChange}
                  />
                </div>
              </div>
            </div>
          </Popup>
        )}
      </>
    );
  }
}

export default CheckCard;
